import { Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { ChangeActiveList } from '../action-creators';
import { NoOp } from '../../ui/action-creators';
import { LOCATION_CHANGE } from 'connected-react-router';
import { ReleaseListKey } from '@common/types/release/release-list-key';
import { SET_ACTIVE_ARTIST } from '../../artist/actions';
import AppState from '../../state';


export const updateActiveListFromUrlEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action>(
      LOCATION_CHANGE,
      SET_ACTIVE_ARTIST
    ),
    withLatestFrom(state$),
    map(([_, state]) => {
      const isReleaseListView = state.router.location.pathname.match(/^\/dashboard\/releases\/([^/]+)+/);

      if (isReleaseListView) {
        return new ChangeActiveList(false, isReleaseListView[1] as ReleaseListKey);
      }

      return new NoOp();
    })
  );